<mat-card class="information-name-card">
  <mat-card-header>
    <div mat-card-avatar class="modbus-header-image">
      <mat-icon aria-hidden="false" aria-label="home icon">account_circle</mat-icon>
    </div>
    <mat-card-title> {{ information.client_name }}   </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div style="text-align: center;"><H1>System: {{ information.client_started }} </H1></div>
    <div style="text-align: center;"><H2>Name: {{ information.client_name }} </H2></div>
    <div style="text-align: center;"><H3>
      {{ information.client_address_1  }}
      {{ information.client_address_2  }}
      {{ information.client_country }}
    </H3></div>
  </mat-card-content>
</mat-card>

